import clsx from 'clsx'
import { FC, useMemo } from 'react'
import { initialQueryState } from '../../../../../../../_metronic/helpers'
import { useQueryRequest } from '../../core/QueryRequestProvider'

type Props = {
  className?: string
  tableProps: any
  title: string
}

const JobCustomHeader: FC<Props> = ({ className, tableProps, title }) => {
  const id = tableProps.column.id
  const { state, updateState } = useQueryRequest()

  const isSelectedForSorting = useMemo(() => {
    return state.sort && state.sort === id
  }, [state, id])

  const order: 'asc' | 'desc' | undefined = useMemo(() => state.order, [state])

  const sortColumn = () => {
    // Skip sorting for these columns
    if (id === 'actions' || id === 'selection') {
      return
    }

    if (!isSelectedForSorting) {
      // Enable sort asc
      updateState({ sort: id, order: 'asc', ...initialQueryState })
      return
    }

    if (isSelectedForSorting && order !== undefined) {
      if (order === 'asc') {
        // Enable sort desc
        updateState({ sort: id, order: 'desc', ...initialQueryState })
        return
      }

      // Disable sort
      updateState({ sort: undefined, order: undefined, ...initialQueryState })
    }
  }

  const {key, ...headerProps} = tableProps.column.getHeaderProps()

  return (
    <th
      key={key}
      {...headerProps}
      className={clsx(
        className,
        isSelectedForSorting && order !== undefined && `table-sort-${order}`,
        (id === 'actions' || id === 'applicants_count') && 'text-center'
      )}
      onClick={sortColumn}
    >
      <span className='text-gray-800'>{title}</span>
    </th>
  )
}

export { JobCustomHeader }
